/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ipWhiteList.vue?vue&type=template&id=fa948d8e"
import script from "./ipWhiteList.vue?vue&type=script&lang=js"
export * from "./ipWhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports